// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.brand-management {
  width: 100%;
}

.brand-management .brand-form-card {
  padding: 24px;
  background: #fff;
  border: 1px solid #e9e7ef;
  border-radius: 14px;
}

.brand-management .brand-form-heading,
.brand-management .brand-preview-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.brand-management .brand-form-heading h3,
.brand-management .brand-preview-heading h3 {
  margin: 0;
  color: #1e1450;
  font-size: 17px;
  font-weight: 700;
}

.brand-management .brand-form-heading p {
  margin: 6px 0 0;
  color: #777487;
  font-size: 13px;
}

.brand-management .brand-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 11px;
  border-radius: 20px;
  background: #f1efff;
  color: #5154b6;
  font-size: 12px;
  white-space: nowrap;
}

.brand-management .brand-field {
  margin-top: 26px;
}

.brand-management .brand-field label,
.brand-management .brand-field-label {
  display: block;
  margin-bottom: 9px;
  color: #29243c;
  font-size: 13px;
  font-weight: 600;
}

.brand-management .brand-text-input {
  width: 100%;
  max-width: 480px;
  height: 44px;
  padding: 0 13px;
  border: 1px solid #dcd9e5;
  border-radius: 8px;
  outline: none;
  color: #29243c;
  background: #fff;
  font-size: 14px;
}

.brand-management .brand-text-input:focus {
  border-color: #5154b6;
  box-shadow: 0 0 0 3px rgb(81 84 182 / 10%);
}

.brand-management .brand-upload-section {
  margin-top: 28px;
}

.brand-management .brand-upload-layout {
  display: flex;
  align-items: center;
  gap: 24px;
  padding: 20px;
  border: 1px dashed #c9c5dc;
  border-radius: 12px;
  background: #faf9fc;
}

.brand-management .brand-preview {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 150px;
  height: 125px;
  overflow: hidden;
  border: 1px solid #e8e5ef;
  border-radius: 10px;
  background: #fff;
}

.brand-management .brand-preview img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: 10px;
}

.brand-management .brand-empty-preview {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: #9994a9;
  font-size: 11px;
}

.brand-management .brand-empty-preview i {
  font-size: 30px;
}

.brand-management .brand-upload-content {
  min-width: 0;
}

.brand-management .brand-upload-content h4 {
  margin: 0 0 7px;
  color: #29243c;
  font-size: 15px;
  font-weight: 650;
}

.brand-management .brand-upload-content p {
  margin: 0 0 8px;
  color: #777487;
  font-size: 13px;
  line-height: 1.6;
}

.brand-management .brand-upload-content .brand-file-hint {
  font-size: 11px;
  color: #9290a0;
}

.brand-management .brand-upload-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  margin-top: 15px;
}

.brand-management .brand-primary-btn,
.brand-management .brand-remove-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 42px;
  padding: 0 18px;
  border-radius: 37px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease;
}

.brand-management .brand-primary-btn {
  color: #fff;
  background: #1e1450;
  border: 1px solid #1e1450;
}

.brand-management .brand-primary-btn:hover {
  background: #312a82;
  border-color: #312a82;
}

.brand-management .brand-remove-btn {
  color: #b42318;
  background: #fff;
  border: 1px solid #ead5d3;
}

.brand-management .brand-remove-btn:hover {
  background: #fff4f3;
}

.brand-management .brand-preview-section {
  margin-top: 30px;
}

.brand-management .brand-preview-heading span {
  padding: 5px 10px;
  border-radius: 20px;
  color: #5154b6;
  background: #f1efff;
  font-size: 11px;
}

.brand-management .brand-preview-banner {
  display: flex;
  align-items: center;
  gap: 15px;
  min-height: 105px;
  margin-top: 14px;
  padding: 18px;
  border: 1px solid #e9e7ef;
  border-radius: 10px;
  background: #f8f7fa;
}

.brand-management .brand-preview-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 65px;
  height: 65px;
  overflow: hidden;
  border: 1px solid #e9e7ef;
  border-radius: 9px;
  background: #fff;
  color: #aaa5b8;
  font-size: 26px;
}

.brand-management .brand-preview-logo img {
  width: 100%;
  height: 100%;
  padding: 5px;
  object-fit: contain;
}

.brand-management .brand-preview-copy {
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 0;
}

.brand-management .brand-preview-copy strong {
  overflow-wrap: anywhere;
  color: #1e1450;
  font-size: 16px;
}

.brand-management .brand-preview-copy span {
  color: #777487;
  font-size: 12px;
}

.brand-management .brand-form-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 28px;
  padding-top: 20px;
  border-top: 1px solid #eeecf2;
}

.brand-management .brand-save-btn {
  min-width: 150px;
}

@media (max-width: 640px) {
  .brand-management .brand-form-card {
    padding: 16px;
  }

  .brand-management .brand-upload-layout {
    flex-direction: column;
    align-items: stretch;
    padding: 16px;
  }

  .brand-management .brand-preview {
    width: 100%;
    height: 150px;
  }

  .brand-management .brand-form-heading {
    align-items: flex-start;
  }

  .brand-management .brand-status {
    font-size: 11px;
  }
}


`, "",{"version":3,"sources":["webpack://./src/pages/tenant/brand-management/BrandManagement.css"],"names":[],"mappings":";AACA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;EAEE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,wDAAwD;AAC1D;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["\n.brand-management {\n  width: 100%;\n}\n\n.brand-management .brand-form-card {\n  padding: 24px;\n  background: #fff;\n  border: 1px solid #e9e7ef;\n  border-radius: 14px;\n}\n\n.brand-management .brand-form-heading,\n.brand-management .brand-preview-heading {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.brand-management .brand-form-heading h3,\n.brand-management .brand-preview-heading h3 {\n  margin: 0;\n  color: #1e1450;\n  font-size: 17px;\n  font-weight: 700;\n}\n\n.brand-management .brand-form-heading p {\n  margin: 6px 0 0;\n  color: #777487;\n  font-size: 13px;\n}\n\n.brand-management .brand-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 7px 11px;\n  border-radius: 20px;\n  background: #f1efff;\n  color: #5154b6;\n  font-size: 12px;\n  white-space: nowrap;\n}\n\n.brand-management .brand-field {\n  margin-top: 26px;\n}\n\n.brand-management .brand-field label,\n.brand-management .brand-field-label {\n  display: block;\n  margin-bottom: 9px;\n  color: #29243c;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.brand-management .brand-text-input {\n  width: 100%;\n  max-width: 480px;\n  height: 44px;\n  padding: 0 13px;\n  border: 1px solid #dcd9e5;\n  border-radius: 8px;\n  outline: none;\n  color: #29243c;\n  background: #fff;\n  font-size: 14px;\n}\n\n.brand-management .brand-text-input:focus {\n  border-color: #5154b6;\n  box-shadow: 0 0 0 3px rgb(81 84 182 / 10%);\n}\n\n.brand-management .brand-upload-section {\n  margin-top: 28px;\n}\n\n.brand-management .brand-upload-layout {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n  padding: 20px;\n  border: 1px dashed #c9c5dc;\n  border-radius: 12px;\n  background: #faf9fc;\n}\n\n.brand-management .brand-preview {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n  width: 150px;\n  height: 125px;\n  overflow: hidden;\n  border: 1px solid #e8e5ef;\n  border-radius: 10px;\n  background: #fff;\n}\n\n.brand-management .brand-preview img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  padding: 10px;\n}\n\n.brand-management .brand-empty-preview {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  color: #9994a9;\n  font-size: 11px;\n}\n\n.brand-management .brand-empty-preview i {\n  font-size: 30px;\n}\n\n.brand-management .brand-upload-content {\n  min-width: 0;\n}\n\n.brand-management .brand-upload-content h4 {\n  margin: 0 0 7px;\n  color: #29243c;\n  font-size: 15px;\n  font-weight: 650;\n}\n\n.brand-management .brand-upload-content p {\n  margin: 0 0 8px;\n  color: #777487;\n  font-size: 13px;\n  line-height: 1.6;\n}\n\n.brand-management .brand-upload-content .brand-file-hint {\n  font-size: 11px;\n  color: #9290a0;\n}\n\n.brand-management .brand-upload-actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 10px;\n  margin-top: 15px;\n}\n\n.brand-management .brand-primary-btn,\n.brand-management .brand-remove-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: 42px;\n  padding: 0 18px;\n  border-radius: 37px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s ease, border-color 0.2s ease;\n}\n\n.brand-management .brand-primary-btn {\n  color: #fff;\n  background: #1e1450;\n  border: 1px solid #1e1450;\n}\n\n.brand-management .brand-primary-btn:hover {\n  background: #312a82;\n  border-color: #312a82;\n}\n\n.brand-management .brand-remove-btn {\n  color: #b42318;\n  background: #fff;\n  border: 1px solid #ead5d3;\n}\n\n.brand-management .brand-remove-btn:hover {\n  background: #fff4f3;\n}\n\n.brand-management .brand-preview-section {\n  margin-top: 30px;\n}\n\n.brand-management .brand-preview-heading span {\n  padding: 5px 10px;\n  border-radius: 20px;\n  color: #5154b6;\n  background: #f1efff;\n  font-size: 11px;\n}\n\n.brand-management .brand-preview-banner {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  min-height: 105px;\n  margin-top: 14px;\n  padding: 18px;\n  border: 1px solid #e9e7ef;\n  border-radius: 10px;\n  background: #f8f7fa;\n}\n\n.brand-management .brand-preview-logo {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 65px;\n  height: 65px;\n  overflow: hidden;\n  border: 1px solid #e9e7ef;\n  border-radius: 9px;\n  background: #fff;\n  color: #aaa5b8;\n  font-size: 26px;\n}\n\n.brand-management .brand-preview-logo img {\n  width: 100%;\n  height: 100%;\n  padding: 5px;\n  object-fit: contain;\n}\n\n.brand-management .brand-preview-copy {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  min-width: 0;\n}\n\n.brand-management .brand-preview-copy strong {\n  overflow-wrap: anywhere;\n  color: #1e1450;\n  font-size: 16px;\n}\n\n.brand-management .brand-preview-copy span {\n  color: #777487;\n  font-size: 12px;\n}\n\n.brand-management .brand-form-footer {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 28px;\n  padding-top: 20px;\n  border-top: 1px solid #eeecf2;\n}\n\n.brand-management .brand-save-btn {\n  min-width: 150px;\n}\n\n@media (max-width: 640px) {\n  .brand-management .brand-form-card {\n    padding: 16px;\n  }\n\n  .brand-management .brand-upload-layout {\n    flex-direction: column;\n    align-items: stretch;\n    padding: 16px;\n  }\n\n  .brand-management .brand-preview {\n    width: 100%;\n    height: 150px;\n  }\n\n  .brand-management .brand-form-heading {\n    align-items: flex-start;\n  }\n\n  .brand-management .brand-status {\n    font-size: 11px;\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
